import styled from "styled-components";

const AquaZoneHeader = () => {
  return (
    <StyledManageParkHeader>
      <StyledPageHeader>{"Aqua Zone Water Sports"}</StyledPageHeader>
    </StyledManageParkHeader>
  );
};

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledManageParkHeader = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding-bottom: 1rem;
  align-items: center;
  @media only screen and (max-width: 768px) {
    padding-bottom: 0.5rem;
  }
`;

const ManageParkHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    padding: 1.5rem;
  }
`;

export default AquaZoneHeader;
